(() => {
  "use strict";
  function t(t, a, n) {
    return (
      a in t
        ? Object.defineProperty(t, a, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (t[a] = n),
      t
    );
  }
  function a() {
    var t =
        arguments.length > 0 && void 0 !== arguments[0]
          ? arguments[0]
          : function () {},
      a = { method: "GET", endpoint: "/cart.js", callback: t };
    n(a);
  }
  function n(t) {
    var a,
      n = t.payload,
      e = t.method,
      o = t.endpoint,
      i = t.callback,
      r = new Headers();
    r.append("Content-Type", "application/json"),
      n && (a = JSON.stringify(n)),
      fetch(o, { method: e, headers: r, body: a, redirect: "follow" })
        .then(function (t) {
          return t.text();
        })
        .then(function (t) {
          t && i(t);
        })
        .catch(function (t) {
          return console.log("error", t);
        });
  }
  function e(e) {
    $(".mr-cart-template-content .cart").addClass("is-loading");
    var o = e.parents(".quantity-controls"),
      i = $(".cart__product-qty", o),
      r = parseInt(i.val()),
      c = 1e17,
      l = i.attr("min") || 0,
      d = i.attr("data-key"),
      s = i.attr("data-line-id"),
      u = i.closest(".cart__row--table").find(".cart__price"),
      p = $(".total-price .cart__subtotal");
    return (
      null != i.attr("max") && (c = i.attr("max")),
      isNaN(r) || r < l
        ? (i.val(l),
          $(".mr-cart-template-content .cart").removeClass("is-loading"),
          !1)
        : r > c
        ? (i.val(c),
          $(".mr-cart-template-content .cart").removeClass("is-loading"),
          !1)
        : ("plus" === e.data("update-quantity")
            ? r < c && (r++, i.val(r))
            : "minus" === e.data("update-quantity") && r > l && (r--, i.val(r)),
          $(".qty-minus", o).attr("disabled", !1),
          $(".qty-plus", o).attr("disabled", !1),
          r >= c &&
            ($(".qty-plus", o).attr("disabled", !0),
            $(".qty-minus", o).attr("disabled", !1)),
          0 == r
            ? (function (t) {
                n({
                  method: "POST",
                  payload: { id: t, quantity: 0 },
                  endpoint: "/cart/change.js",
                  callback:
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : function () {},
                });
              })(d, function () {
                a(function (t) {
                  var a = JSON.parse(t),
                    n = a.items,
                    o = a.total_price,
                    i = n
                      .filter(function (t) {
                        return t.id == s;
                      })
                      .shift();
                  e.closest(".cart__row").remove(),
                    $(".mr-cart-template-content .cart").removeClass(
                      "is-loading"
                    ),
                    0 == n.length &&
                      ($(".mr-cart-template-content").html(""),
                      window.location.reload()),
                    void 0 !== i &&
                      (u.text(
                        "$".concat((i.final_line_price / 100).toFixed(2))
                      ),
                      p.text("$".concat((o / 100).toFixed(2))));
                });
              })
            : (function (a, e) {
                var o =
                  arguments.length > 2 && void 0 !== arguments[2]
                    ? arguments[2]
                    : function () {};
                n({
                  method: "POST",
                  payload: { updates: t({}, a, e) },
                  endpoint: "/cart/update.js",
                  callback: o,
                });
              })(d, r, function () {
                a(function (t) {
                  var a = JSON.parse(t),
                    n = a.items,
                    e = a.total_price,
                    o = n
                      .filter(function (t) {
                        return t.id == s;
                      })
                      .shift();
                  u.text("$".concat((o.final_line_price / 100).toFixed(2))),
                    p.text("$".concat((e / 100).toFixed(2))),
                    $(".mr-cart-template-content .cart").removeClass(
                      "is-loading"
                    );
                });
              }),
          void console.log(cart_empty, "CART EMPTY"))
    );
  }
  $(".cart__row .cart__product-qty").on("change", function () {
    e($(this));
  }),
    $("[data-update-quantity]:not([disabled])").on("click", function () {
      e($(this));
    });
})();
